import styled, { createGlobalStyle } from 'styled-components';
import { Modal } from 'antd';

const featureColor = 'rgba(60, 28, 14, 0.72)';

export const NpsFontFace = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&family=Inter:wght@400;500;600&display=swap');
`;

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    position: relative; overflow: hidden; border-radius: 14px;
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.45);
  }
  .ant-modal-body { padding: 0; }

  button { padding: 0; border: none; background: transparent; cursor: pointer; }

  .accent { height: 5px; background: linear-gradient(90deg, #a9772e 0%, #c9922e 45%, #e0aa4a 100%); }

  .close {
    position: absolute; top: 20px; right: 22px; z-index: 1;
    display: flex; align-items: center; justify-content: center;
    width: 26px; height: 26px; border-radius: 6px;
    color: #b9bcc2; font-size: 20px; line-height: 1;
    transition: color 0.15s ease, background 0.15s ease;
    &:hover { color: #6b6e75; background: #f1f2f4; }
  }

  .content { padding: 46px 60px 40px; font-family: 'Inter', sans-serif; }

  .brand {
    display: block; margin-bottom: 26px;
    font-family: 'Poppins', sans-serif; font-weight: 700; font-size: 22px;
    letter-spacing: -0.5px; color: #1b1b1f;
  }

  .question {
    margin: 0 0 30px; max-width: 640px;
    font-family: 'Poppins', sans-serif; font-weight: 600; font-size: 25px;
    line-height: 1.35; color: #24242a; text-wrap: balance;
  }

  .scores { display: flex; justify-content: space-between; gap: 6px; margin-bottom: 34px; }

  .score {
    flex: 1; display: flex; flex-direction: column; align-items: center;
    gap: 9px; padding: 6px 0; transition: transform 0.12s ease;
    &:hover, &.selected { transform: translateY(-3px); }
  }

  .face {
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    gap: 5px; flex-shrink: 0; width: 44px; height: 44px; border-radius: 50%;
    box-shadow: inset 0 -4px 7px rgba(0, 0, 0, 0.14), 0 2px 4px rgba(0, 0, 0, 0.12);
    transition: box-shadow 0.15s ease, transform 0.15s ease;
  }

  .score.selected .face {
    transform: scale(1.12);
    box-shadow: inset 0 -4px 7px rgba(0, 0, 0, 0.14), 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 0 3px var(--ring);
  }

  .score.selected .score-number {
    font-size: 14.5px;
  }

  .eyes { display: flex; gap: 9px; }
  .eye { width: 5px; height: 5px; border-radius: 50%; background: ${featureColor}; }

  .mouth.flat { width: 16px; height: 3px; margin-top: 4px; border-radius: 2px; background: ${featureColor}; }
  .mouth.sad, .mouth.happy {
    box-sizing: content-box; width: 18px; height: 9px; margin-top: 1px;
    border: 3px solid ${featureColor};
  }
  .mouth.sad { border-bottom: none; border-radius: 18px 18px 0 0; }
  .mouth.happy { border-top: none; border-radius: 0 0 18px 18px; }

  .score-number { font-size: 13px; font-weight: 600; line-height: 1; }

  .field { margin-bottom: 30px; }
  .field-label { display: block; margin-bottom: 8px; font-size: 13.5px; font-weight: 500; color: #6b6e75; }
  .optional { font-weight: 400; color: #a4a7ad; }

  .justification {
    box-sizing: border-box; width: 100%; padding: 12px 14px; resize: none;
    border: 1px solid #dcdee2; border-radius: 8px;
    font-family: 'Inter', sans-serif; font-size: 14px; color: #33343a;
    background: #fbfbfc; outline: none;
    transition: border-color 0.15s ease, background 0.15s ease;
    &:focus { border-color: #c9922e; background: #ffffff; }
  }

  .actions { display: flex; align-items: center; justify-content: space-between; gap: 18px; }

  .remind {
    padding: 8px 4px; font-size: 12.5px; font-weight: 500; color: #9a9da3;
    text-decoration: underline; text-underline-offset: 3px;
    transition: color 0.15s ease;
    &:hover { color: #6b6e75; }
  }

  .submit {
    padding: 13px 34px; border-radius: 8px;
    background: linear-gradient(180deg, #e8973c 0%, #dd8730 100%);
    box-shadow: 0 6px 16px rgba(221, 135, 48, 0.35);
    font-family: 'Poppins', sans-serif; font-size: 14.5px; font-weight: 600;
    letter-spacing: 0.3px; color: #ffffff;
    transition: filter 0.15s ease;
    &:hover { filter: brightness(1.05); }
  }

  @media (max-width: 768px) {
    .content { padding: 36px 28px 28px; }
    .question { font-size: 21px; }
  }

  @media (max-width: 640px) {
    .scores { flex-wrap: wrap; justify-content: center; gap: 8px 4px; }
    .score { flex: 0 0 auto; width: 46px; gap: 7px; }
    .face { width: 38px; height: 38px; gap: 4px; }
    .eyes { gap: 7px; }
  }

  @media (max-width: 480px) {
    .content { padding: 32px 20px 24px; }
    .actions { flex-direction: column-reverse; align-items: stretch; gap: 14px; }
  }
`;
